<script setup>

</script>

<template>
  <div class="form-layout">
    <div class="form-layout__header">
      <slot name="title"></slot>
      <slot name="actions"></slot>
    </div>
    <div class="form-layout__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./form-layout";
</style>
